
    import '/opt/buildhome/repo/packages/x/docs/react/model-use-openai.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-react-model-use-openai-demo-model","docs-react-model-use-openai-demo-openai-node"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/model-use-openai.en-US.md?type=demo')
};